module.exports = __webpack_public_path__ + "img/kn_bubble.625a53c8.svg";